/*
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2022-10-09 17:21:59
 * @LastEditors: shenlin
 * @LastEditTime: 2022-10-10 11:27:41
 */
const BASE_URL = '/lishui-gov'
const BASE = '/dev-api'
import request from '@/common/api/request'
// 取消订单列表
export const listByCancelPage = params =>
  request(BASE_URL + '/govGoodsOrder/listByCancelPage', { params })
// 取消订单列表
export const listByCancelRecord = params =>
  request(BASE_URL + '/govGoodsOrder/listByCancelRecord', { params })
// 取消订单列表
export const auditCancelOrder = data =>
  request.post(BASE_URL + '/govGoodsOrder/auditCancelOrder', data)
